/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import NotFoundPage from '../modules/NotFound';

const CustomRoute = ({
  component: Component,
  required_auth,
  event_active,
  ...rest
}) => {
  const [user, marketplace] = useSelector(state => [
    state.user,
    state.marketplace
  ]);

  useEffect(() => {
    if (required_auth && !user.authorized) {
      localStorage.setItem(
        'user.marketplace.redirect_path',
        rest.path.replace('/:marketplace_uid', '')
      );
    }
  }, [rest]);

  return (
    <Route
      {...rest}
      render={props =>
        event_active && !marketplace.status ? (
          <Route component={NotFoundPage} />
        ) : required_auth ? (
          user.authorized ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={`${process.env.PUBLIC_URL}/${marketplace.uid}/login`}
            />
          )
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default CustomRoute;
